import React from 'react';
import PropTypes from 'prop-types';

// Inherits colour from the button it sits in, so callers style it with `color`.
const CopyIcon = ({ size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    aria-hidden="true"
    focusable="false"
  >
    <rect
      x="5.5"
      y="5.5"
      width="8"
      height="8"
      rx="1.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
    />
    <path
      d="M10.5 3.5A1.5 1.5 0 0 0 9 2H4a1.5 1.5 0 0 0-1.5 1.5v5A1.5 1.5 0 0 0 4 10"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
);

CopyIcon.propTypes = {
  size: PropTypes.number,
};

CopyIcon.defaultProps = {
  size: 12,
};

export default CopyIcon;
